import React, { useState } from "react";
import codeStyle from './icdCode.module.scss'

const CodePage = ({ highCode, highDesc, lowCode, lowDesc, riskV28, hccCode, hcc, icd10Code, icd10Descriptions }) => {
    const riskV281 = riskV28 ? riskV28.split(',') : [];
    const hccCode1 = hccCode ? hccCode.split(',') : [];

    const combinedRiskHcc = riskV281
    .map((risk, index) => ({
      risk: parseFloat(risk.trim()),  
      hcc: hccCode1[index].trim()    
    }))
    .filter(
      (item, index, self) =>
        index === self.findIndex(
          t => t.risk === item.risk && t.hcc === item.hcc
        )
    )
    .sort((a, b) => b.risk - a.risk);
  
    const icd10Codes1 = typeof icd10Code === 'string' ? JSON.parse(icd10Code) : icd10Code;
    const icd10Descriptions1 = typeof icd10Descriptions === 'string' ? JSON.parse(icd10Descriptions) : icd10Descriptions;

    return (
        <>
            {!hcc ? <table className={`${codeStyle.table} no-border-table`}>
                <thead>
                    <tr>
                        <th className={codeStyle.codeTitle}>ICD-10 Code</th>
                        <th className={codeStyle.codeTitle}>Description</th>
                    </tr>
                </thead>

                <tbody>
                    {/* {highCode && [...new Set(highCode)].map((code, index) => (
                        highDesc[index] ? (
                            <tr key={index}>
                                <td className={codeStyle.subTitle}>{code}</td>
                                <td className={codeStyle.subTitle}>{highDesc[index]}</td>
                            </tr>
                        ) : null
                    ))}
                    {lowCode && [...new Set(lowCode)].map((code, index) => (
                        lowDesc[index] ? (
                            <tr key={index + highCode.length}>
                                <td className={codeStyle.subTitle}>{code}</td>
                                <td className={codeStyle.subTitle}>{lowDesc[index]}</td>
                            </tr>
                        ) : null
                    ))} */}
                  
                    {icd10Codes1 && icd10Codes1.length > 0 &&
                        [...new Set(icd10Codes1)].map((code, index) => {
                            const originalIndex = icd10Codes1.indexOf(code);
                            return (
                                icd10Descriptions1[originalIndex] ? (
                                    <tr key={index}>
                                        <td className={codeStyle.subTitle}>{code}</td>
                                        <td className={codeStyle.subTitle}>{icd10Descriptions1[originalIndex]}</td>
                                    </tr>
                                ) : null
                            );
                        })
                    }

                </tbody>
            </table>
                : <table className={`${codeStyle.table} no-border-table`}>
                    <thead>
                        <tr>
                            <th className={codeStyle.codeTitle}>Risk V28</th>
                            <th className={codeStyle.codeTitle}>HCC Code</th>
                        </tr>
                    </thead>
                    <tbody>
                        {combinedRiskHcc.map((item, index) => (
                            <tr key={index}>
                                <td className={codeStyle.subTitle}>{item.risk}</td>
                                <td className={codeStyle.subTitle}>{item.hcc}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>}
        </>
    )
}

export default CodePage;
